import { render, staticRenderFns } from "./TemplateSidePanel.vue?vue&type=template&id=6a5b096f"
import script from "./TemplateSidePanel.vue?vue&type=script&lang=js"
export * from "./TemplateSidePanel.vue?vue&type=script&lang=js"
import style0 from "./TemplateSidePanel.vue?vue&type=style&index=0&id=6a5b096f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports